import moment from 'moment'

import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import { setEnrollmentReportList } from 'src/store/modules/reports'

import {
  DATE_TIME_FORMAT_FOR_SERVER,
  GET_ENROLLMENT_REPORT_LIST
} from 'src/constants'
import { exportReport } from 'src/utils/Functions'

export const getEnrollmentReportList =
  (config = {}) =>
  async (dispatch) => {
    const { params = {}, query = {} } = config

    try {
      const { items = [], meta = {} } = await httpClient.request({
        method: 'get',
        url: {
          pathname: GET_ENROLLMENT_REPORT_LIST,
          params,
          query
        }
      })

      dispatch(setEnrollmentReportList(items))

      return meta
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const exportEnrollmentReport =
  (config = {}) =>
  async () => {
    await exportReport(
      config,
      `enrollment_report_${moment().format(DATE_TIME_FORMAT_FOR_SERVER)}.xls`
    )
  }
